var map = {
	"./icon-biologia.svg": 87418,
	"./icon-fizyka.svg": 29860,
	"./icon-geografia-rozszerzona.svg": 22145,
	"./icon-informatyka.svg": 93453,
	"./icon-matematyka-rozszerzona.svg": 42738,
	"./icon-matematyka.svg": 20728,
	"./icon-wie.svg": 70445,
	"./icon-wiedza-o-spoleczenstwie.svg": 94174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43700;